export const DepthChartSkeleton = () => {
  return (
    <div className="container flex size-full animate-pulse flex-col p-4">
      <div className="flex h-full min-h-0 grow justify-center">
        <div className="size-full rounded bg-gray-700"></div>
      </div>

      <div className="mt-1 flex gap-2">
        <div className="h-4 w-full rounded bg-gray-700"></div>
        <div className="h-4 w-full rounded bg-gray-700"></div>
        <div className="h-4 w-full rounded bg-gray-700"></div>
        <div className="h-4 w-full rounded bg-gray-700"></div>
        <div className="h-4 w-full rounded bg-gray-700"></div>
      </div>
    </div>
  );
};
